

export function getLogoLing() {
    let logolink = "/Home";

    if (global.$header != null && global.$header.logolink != null) {
        logolink = global.$header.logolink
    }

    return logolink;
}
